export const nonStandardUtilisationUrls = [
	'universityofleeds.omniscanpro.cloud'
];

